import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';

// We created this wrapper to modify the payload to include cmdbArchitecture as a new attribute.
// Decided not to continue with this. The wrapper remains.
export const fireCmdbErrorAnalytics: typeof fireErrorAnalytics = (payload) => {
	return fireErrorAnalytics(payload);
};
